<div *ngIf="(loadingForm$ | async) === false; else loading">
  <glxy-label>
    <b>{{ 'AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_VERIFIED.TITLE' | translate }}</b>
  </glxy-label>
  <p>
    {{
      'AUTOMATIONS.EDITOR.TRIGGERS.EMAIL_VERIFIED.DESCRIPTION'
        | translate : { businessAppName: businessAppName$ | async }
    }}
  </p>
</div>

<ng-template #loading>
  <div class="content side-drawer-shimmer-container"></div>
</ng-template>
